import MapPinIcon from '../../assets/icons/map-pin.svg?react';
import { Machine } from '../../types/machines/machine.types';
import { machineTableImage } from '../../demo/demoMode';

interface MachineNameCellProps {
  machine: Machine;
}

/** The table's first cell: the picture, the name, and where the machine stands. */
export function MachineNameCell({ machine }: MachineNameCellProps) {
  const name = machine.displayName || machine.machineId || 'Unknown';

  return (
    <div className='flex min-w-0 items-start gap-3'>
      <div
        className='bg-surface-primary-support flex h-12 w-12 shrink-0
          items-center justify-center overflow-hidden rounded-lg p-1'
      >
        <img
          src={machineTableImage(machine.family)}
          // The Family column names the family, so the picture adds nothing a
          // reader needs.
          alt=''
          className='h-full w-full object-contain'
          loading='lazy'
          decoding='async'
        />
      </div>

      <div className='flex min-w-0 flex-col'>
        <span className='size-p2 text-focus truncate font-bold'>{name}</span>

        {machine.plant && (
          <span
            className='size-caption text-secondary flex min-w-0 items-center
              gap-1'
          >
            <MapPinIcon aria-hidden className='h-3 w-3 shrink-0' />
            <span className='truncate'>{machine.plant}</span>
          </span>
        )}
      </div>
    </div>
  );
}
